import React from "react"

const Pregunta = ({ pregunta, respuesta }) => {
  return (
    <li className="bg-blanco sombra p1">
      <h3>{pregunta}</h3>
      <p>{respuesta}</p>
    </li>
  )
}

export default Pregunta
